module.exports = __webpack_public_path__ + "static/img/fengxiantishi.640ea24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fengxiantishi.png
// module id = aHxZ
// module chunks = 1